import { doMutation } from "../../core-module/util/graphqlHelper";

export const deleteSubRole = id => {
  const mutation = require("../api/mutation/deleteSubRole.gql");
  const variables = {
    id: id,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) return { data: data.deleteSubRole };
    else if (error) return { error: JSON.stringify(error) };
  });
};
